module.exports = __webpack_public_path__ + "img/by.0c37e553.svg";